// axios
import axios from 'axios'
import { tokenize } from 'prismjs';

let token;
let staff;
let baseURL = ''
let user = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')) : null;
if(user !== null && user.companies !== undefined) {
  staff = false;
  token = JSON.parse(localStorage.getItem('companytoken'));
  baseURL = process.env.VUE_APP_COMPANY_API_DOMAIN
} else {
  staff = true;
  token = JSON.parse(localStorage.getItem('stafftoken'));
  baseURL = process.env.VUE_APP_STAFF_API_DOMAIN
}


const instance = axios.create({
  baseURL,
  headers: {
    Authorization: 'Bearer ' + token
  }
})

export default instance;
